import React from 'react';
import RegistrationContainer from '../../components/profile/containers/RegistrationContainer';

const EditarPerfil = () =>

    // eslint-disable-next-line implicit-arrow-linebreak
    (
        <div className="tw-container tw-px-5 tw-m-auto pageWrapper">
            <RegistrationContainer />
        </div>
    );

export default EditarPerfil;
